import { render, staticRenderFns } from "./SearchTransfers.vue?vue&type=template&id=55b3085a&"
import script from "./SearchTransfers.vue?vue&type=script&lang=js&"
export * from "./SearchTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports